import { render, staticRenderFns } from "./job-employment-position-helper-components-4-job-employment-position-resource-item.vue?vue&type=template&id=053722a2&"
import script from "./job-employment-position-helper-components-4-job-employment-position-resource-item.vue?vue&type=script&lang=ts&"
export * from "./job-employment-position-helper-components-4-job-employment-position-resource-item.vue?vue&type=script&lang=ts&"
import style0 from "./job-employment-position-helper-components-4-job-employment-position-resource-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon})
